import { render, staticRenderFns } from "./registeredDeta.vue?vue&type=template&id=6f64f042&scoped=true"
import script from "./registeredDeta.vue?vue&type=script&lang=js"
export * from "./registeredDeta.vue?vue&type=script&lang=js"
import style0 from "./registeredDeta.vue?vue&type=style&index=0&id=6f64f042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f64f042",
  null
  
)

export default component.exports